import {
  IValueSpecifiable, instanceOfIValueSpecifiable,
} from "../../../../base/domain/entity";
import { IEnableSpecifiable, instanceOfIEnableSpecifiable } from "../../../../base/domain/drawing";

export interface IBookmark<T = string> extends IEnableSpecifiable, IValueSpecifiable<T> {
  row: number;
  column: number;
}

export function instanceOfIBookmark<T = string>(instance: any): instance is IBookmark<T> {
  return instance
    && (instance.row !== undefined)
    && (instance.column !== undefined)
    && instanceOfIEnableSpecifiable(instance)
    && instanceOfIValueSpecifiable<T>(instance);
}
